module.exports = __webpack_public_path__ + "img/rlnotice_footer.f121a61a.png";